/* eslint-disable no-restricted-imports */
import { FC } from 'react';
import { Box } from '../layout/Box';
import { getLinkProps } from '../posts/utils/getLinkProps';
import { CollectionAuthorInfo } from './CollectionAuthorInfo/CollectionAuthorInfo';
import { ContentItem, ScrollableHeaderContainer, ScrollableHeaderContent } from './styles';
import { CollectionScrollableHeaderProps } from './types';

export const CollectionScrollableHeader: FC<CollectionScrollableHeaderProps> = ({
    collectionModel,
    targetRef,
    collectionInfo,
    ...other
}) => {
    const { author, modifiable } = collectionModel || {};

    const showAuthorInfo = author && !modifiable;
    if (!collectionModel || (!collectionInfo && !showAuthorInfo)) {
        return null;
    }

    return (
        <ScrollableHeaderContainer {...other}>
            <ScrollableHeaderContent>
                {collectionInfo ? <ContentItem>{collectionInfo}</ContentItem> : null}
                {showAuthorInfo ? (
                    <ContentItem {...getLinkProps(author?.shareLink)}>
                        <CollectionAuthorInfo
                            collectionModel={collectionModel}
                            view="authorBadge"
                        />
                    </ContentItem>
                ) : null}
            </ScrollableHeaderContent>
            <Box ref={targetRef} />
        </ScrollableHeaderContainer>
    );
};
